import { _ as r } from "../internals/export.js";
import { f as t } from "../internals/fails.js";
import { i as n } from "../internals/is-constructor.js";
import { c as o } from "../internals/create-property.js";
var s = Array;
r({
  target: "Array",
  stat: !0,
  forced: t(function () {
    function r() {}
    return !(s.of.call(r) instanceof r);
  })
}, {
  of: function of() {
    for (var r = 0, t = arguments.length, a = new (n(this) ? this : s)(t); t > r;) o(a, r, arguments[r++]);
    return a.length = t, a;
  }
});